import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { up } from 'styled-breakpoints';
import { Focus } from '@fenderdigital/ui/utils/css';
import { Search as SearchIcon, CloseIcon as XIcon } from '@fenderdigital/ui/Icons';

interface InputProps {
  isTransparent?: boolean;
  isMobile?: boolean;
}
export const SearchContainer = styled.div`
  display: flex;
`;
export const SearchForm = styled.form`
  position: relative;
  align-self: center;
`;

export const Input = styled.input<InputProps>`
  height: 2rem;
  width: 23.938rem;
  border: solid 1px
    ${({ isTransparent, theme }): string =>
      isTransparent ? theme.colors.white : theme.colors.black};
  border-radius: 17px;
  padding-left: 2.75rem;
  padding-right: 2.25rem;
  font-family: ${({ theme }): string => theme.fonts.sourceSans};
  font-size: ${({ theme }): string => theme.fontSizes.f2};
  background-color: ${({ isTransparent, theme }): string =>
    isTransparent ? 'rgba(0, 0, 0, 0.35)' : theme.colors.white};
  color: ${({ isTransparent, theme }): string =>
    isTransparent ? theme.colors.white : theme.colors.black};
  transition: all ease-out 0.3s;

  ${Focus}

  &::placeholder {
    color: ${({ isTransparent, theme }): string =>
      isTransparent ? theme.colors.white : '#595959'};
  }
`;

export const CloseButton = styled.button<InputProps>`
  @keyframes close-button {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  z-index: 1;
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  background-color: ${({ theme }): string => theme.colors.white};
  border-radius: 1rem;
  right: 0.8rem;
  top: 1.13rem;
  transition: background-color ease-out 0.3s;

  ${({ isMobile }): string => (isMobile ? 'animation: close-button 0.5s linear;' : '')};

  ${up('tablet-portrait')} {
    background-color: ${({ theme, isTransparent }): string =>
      isTransparent ? theme.colors.black : theme.colors.white};
    right: 8.2rem;
  }

  ${up('tablet-landscape')} {
    right: 8.5rem;
  }

  ${Focus}
`;

export const CloseIcon = styled(XIcon)<InputProps>`
  height: 1.5rem;
  width: 1.5rem;
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f8};
`;

export const MobileSearchContainer = styled.div`
  position: relative;
  align-self: center;
  width: 2.25rem;
  height: 2.25rem;
`;

export const MobileSearchWrapper = styled.div<{ showSearch: boolean }>`
  position: absolute;
  transition: right 0.45s;
  transition-timing-function: cubic-bezier(0.35, 0, 0, 1);
  right: 0;

  ${({ showSearch }): FlattenSimpleInterpolation | string =>
    showSearch
      ? css`
          right: calc(100vw - 8rem);
          z-index: 1;
        `
      : ''}
`;

export const MobileInput = styled.input`
  @keyframes input {
    from {
      opacity: 0;
      left: 100%;
    }
    to {
      opacity: 1;
      left: 2.75rem;
    }
  }

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
  width: calc(100% - 90px);
  border: none;
  padding: 0 0 0 1rem;
  border-radius: 1.875rem;

  animation: input 0.45s cubic-bezier(0.35, 0, 0, 1);

  &:active,
  :focus {
    outline-width: 0px;
    box-shadow: rgb(185 205 241) 0px 0px 0px 3px;
    transition: box-shadow 0.25s ease-out;
    transition-delay: 0.25s;
  }
`;

export const InputContainer = styled.form`
  @keyframes opacity {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  z-index: 1;
  background-color: white;
  position: absolute;
  width: 100vw;
  height: 3.6875rem;
  padding: 0.875rem 3.2rem 0.875rem 2.75rem;
  border: none;
  top: 0;
  left: 0;

  animation: opacity 0.45s cubic-bezier(0.5, 0.35, 0.15, 1);
`;

export const MobileSearchButton = styled.button<{ showSearch: boolean }>`
  z-index: 1;
  border-radius: 0.5rem;
  padding: 0.5rem;
  ${Focus}

  svg {
    ${({ showSearch }): string => (showSearch ? 'fill: black !important' : '')};
  }
`;

export const MobileSearchIcon = styled(SearchIcon)`
  transition: fill 0.45s cubic-bezier(0.35, 0, 0, 1);
`;
